import { Sparkles, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router';

const DISMISS_KEY = 'weather-story-upgrade-dismissed';
const DISMISS_DAYS = 7;

function isDismissed(): boolean {
  const dismissed = localStorage.getItem(DISMISS_KEY);
  if (!dismissed) return false;
  const expiresAt = parseInt(dismissed, 10);
  if (Date.now() > expiresAt) {
    localStorage.removeItem(DISMISS_KEY);
    return false;
  }
  return true;
}

interface UpgradeBannerProps {
  className?: string;
}

export function UpgradeBanner({ className = '' }: UpgradeBannerProps) {
  const [visible, setVisible] = useState(!isDismissed());

  if (!visible) return null;

  const handleDismiss = () => {
    const expiresAt = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(DISMISS_KEY, expiresAt.toString());
    setVisible(false);
  };

  return (
    <div
      className={`relative bg-gradient-to-r from-primary-900/50 to-purple-900/50 border border-primary-700/30 rounded-2xl p-6 ${className}`}
    >
      <button
        onClick={handleDismiss}
        className="absolute top-3 right-3 text-gray-500 hover:text-gray-300 transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>

      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-center gap-3 shrink-0">
          <div className="p-2 bg-primary-500/20 rounded-lg">
            <Sparkles className="h-5 w-5 text-primary-400" />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-gray-100 mb-1">
            Enjoying the stories? Try Basic free for 7 days
          </h4>
          <p className="text-xs text-gray-400">
            Remove ads, save 3 locations, unlock story archives, and get priority story generation.
          </p>
        </div>

        <Link
          to="/subscription"
          className="shrink-0 inline-flex items-center gap-1.5 bg-primary-600 hover:bg-primary-500 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
        >
          Start Free Trial
        </Link>
      </div>
    </div>
  );
}
